

import { Card, TextField, Typography } from '@mui/material'
import HeaderGestorConfigs from '../../../../../utils/headerGestorConfigs'
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import api from '../../../../../services/api';
import LoadingShort from '../../../../../load/loadingShort';
import MessageSuccess from '../../../../../messages/messageSuccess';
import MessageError from '../../../../../messages/messageError';
import ButtonLeft from '../../../../../utils/buttonLeft';

export default function AtribuicaoQuota({ setProduto, produto }) {
    const user = useSelector(state => state.account.user);
    const dispatch = useDispatch()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [load, setLoad] = useState(false)
    const [quotaDisponivel, setQuotaDisponivel] = useState(0)
    const [quota, setQuota] = useState(0)
    const [CalculaQuota, setCalculaQuota] = useState(quotaDisponivel)

    useEffect(() => {
        api.get(`/get/quota-disponivel`)
            .then(response => {
                setQuotaDisponivel(response.data.quota);
            }).catch(err => {
                // console.log(err)
                setMessageError(err.response.data.message)
            });
    }, [produto])

    useEffect(() => {
        setCalculaQuota(quotaDisponivel - quota)
    }, [quota, quotaDisponivel])

    const handleQuota = () => {
        setLoad(true)
        api.patch('/producto/edit-quota', {
            // status: status,
            productoId: produto._id,
            quota,
            userId: user?._id
        }).then(response => {
            setProduto(response.data.producto)
            dispatch({
                type: 'alert',
                payload: { alert: 'Quota atribuida com sucesso.!' },
            });
            // console.log(response)
        }).catch(error => {
            // console.log(error)
            setMessageError(error.response.data.message)
        }).finally(() => setLoad(false))
    }

    return (

        <Card style={{ padding: 20 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs
                menu={false}
                configArea={''}
                title={'ATRIBUIÇÃO DE QUOTA'}
            />
            {CalculaQuota ?
                <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Quota disponivel:</strong> {CalculaQuota}</Typography>
                :
                <LoadingShort text={'A verificar quota disponivel'} />
            }
            <br />
            <TextField
                type='number'
                size="small"
                fullWidth
                label="Atribuir quota"
                defaultValue={produto?.quota}
                onChange={(e) => setQuota(e.target.value)}
                variant="outlined" />

            <ButtonLeft funcao={handleQuota}  title={'salvar'} disabled={load || quota > quotaDisponivel} load={load}/>
        </Card>
    )
}
